import React, { createContext, useContext, FC } from 'react';
import { useHash } from 'clientState/hooks/useUrlParams';

type SemTripTypeFilterContextType = {
  tripTypeSelected: string;
  selectTripTypeFilter: (tripType: string) => void;
  applyTripTypeFilter: () => void;
};

export const SemTripTypeFilterContext =
  createContext<SemTripTypeFilterContextType>(
    {} as SemTripTypeFilterContextType
  );

export const useSemTripTypeFilter = (): SemTripTypeFilterContextType =>
  useContext(SemTripTypeFilterContext);

const SemTripTypeFilterProvider: FC = ({ children }) => {
  const hash = useHash();
  const [tripTypeSelected, setTripTypeSelected] = React.useState<string>('');

  const selectTripTypeFilter = (tripType: string): void => {
    setTripTypeSelected(tripType);
  };

  const applyTripTypeFilter = (): void => {
    const tripTypeUrl = tripTypeSelected === 'ROUND_TRIP' ? 'R' : 'O';
    const newHash = hash.replace(/type=[OR];/g, `type=${tripTypeUrl};`);
    window.location.hash = newHash;
  };

  const value = {
    tripTypeSelected,
    selectTripTypeFilter,
    applyTripTypeFilter,
  };

  return (
    <SemTripTypeFilterContext.Provider value={value}>
      {children}
    </SemTripTypeFilterContext.Provider>
  );
};

export default SemTripTypeFilterProvider;
